export const ajax_utils = {};

ajax_utils.CONTENT_TYPE_JSON = 'application/json';
ajax_utils.CONTENT_TYPE_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8';

ajax_utils.convert_to_urlencoded_string = (formvals) => {
  // convert object with data for post method request to url encoding (URL query) string
  // 'application/x-www-form-urlencoded;charset=UTF-8';
  // PHP http_build_query — Generate URL-encoded query string
  const params = new URLSearchParams();
  for (const [key, val] of Object.entries(formvals)) {
    params.append(key, val);
  }
  return params.toString();
};

ajax_utils.convert_to_json = (obj) => {
  const json = JSON.stringify(obj);
  return json;
};

